import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';

export interface RssConfig {
  feedUrl: string;
  enabled: boolean;
  autoPublish: boolean;
  lastImportedAt: string | null;
  lastStatus: string | null;
  lastError: string | null;
}

export interface RssImportResult {
  imported: number;
  skipped: number;
  failed: number;
}

export interface RssImageVerifyResult {
  checked: number;
  healthy: number;
  repaired: number;
  missingOnSource: number;
  unresolved: number;
}

export interface UpdateRssConfigInput {
  feedUrl?: string;
  enabled?: boolean;
  autoPublish?: boolean;
}

const QK = { config: ['rss-config'] as const };

export function useRssConfig() {
  return useQuery({
    queryKey: QK.config,
    queryFn: async () => {
      const res = await apiClient.get<RssConfig>('/rss-config');
      return res.data;
    },
  });
}

export function useUpdateRssConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (input: UpdateRssConfigInput) => {
      const res = await apiClient.put<RssConfig>('/rss-config', input);
      return res.data;
    },
    onSuccess: (data) => qc.setQueryData(QK.config, data),
  });
}

export function useRunRssImport() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await apiClient.post<RssImportResult>('/rss-import/run', {});
      return res.data;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QK.config });
      qc.invalidateQueries({ queryKey: ['posts'] });
    },
  });
}

export function useVerifyRssImages() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await apiClient.post<RssImageVerifyResult>('/rss-import/verify-images', {});
      return res.data;
    },
    onSuccess: (r) => {
      // Le copertine ripristinate cambiano i post → rinfresca le liste.
      if (r.repaired > 0) qc.invalidateQueries({ queryKey: ['posts'] });
    },
  });
}
